import React from 'react';
function TranscriptsIcon(props){
    return(
        <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g  stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g transform="translate(-285.000000, -739.000000)" stroke="#007CB0">
                    <g transform="translate(285.000000, 740.000000)">
                        <path d="M0,0 L10,0 M0,3 L14,3 M0,6 L13,6 M0,9 L14,9 M0,12 L9,12"></path>
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default TranscriptsIcon;
